/** Admin: hardware order detail for one owner (owner-twin, read). */
import React from 'react';
import { useLocalSearchParams } from 'expo-router';
import { OwnerScopeProvider } from '../../../../../../src/context/OwnerScopeContext';
import OrderDetail from '../../../../../owner/shop/orders/[id]';

export default function AdminOwnerShopOrderDetailScreen() {
  const { id, orderId } = useLocalSearchParams<{ id: string; orderId: string }>();
  return (
    <OwnerScopeProvider ownerId={id}>
      <OrderDetail entityId={orderId} />
    </OwnerScopeProvider>
  );
}
